import React, { Fragment, useEffect } from "react";
import { GlobalOutlined, MailOutlined } from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import { Col, Row } from "reactstrap";
import store from "../store";
import { LOGOUT, UPDATE_STATE_COMPLETELY } from "../actions/types";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { languageUserSessionData } from "../api/dashboard/genericFunction";
import ConceptXIntro from "./login/ConceptXIntro";

const LoginApp = ({ children, setLogoutProvision }) => {
  useEffect(() => {
    store.dispatch({
      type: UPDATE_STATE_COMPLETELY,
      payload: languageUserSessionData(),
    });
  }, []);
  useEffect(() => {
    if (setLogoutProvision) {
      store.dispatch({ type: LOGOUT });
    }
  }, [setLogoutProvision]);
  return (
    <Fragment>
      <div>
        <Row>
          <Col
            sm="8"
            className="p-0 position-relative"
            style={{ minHeight: "100vh", background: "#000" }}
          >
            <ConceptXIntro />
          </Col>
          <Col sm="4 p-0 position-relative" style={{ background: "#fff" }}>
            <div className="mb-2 pb-3 pt-2 text-center ">
              <div
                style={{ width: "100%", marginTop: "10vh" }}
                className=" text-center "
              >
                <img
                  src={require("../assets/images/lambda.png")}
                  alt=""
                  style={{ width: "auto", height: "54px" }}
                />
                <h5 className="mt-2 mb-0 pb-0" style={{ fontWeight: "normal" }}>
                  AI powered inspections
                </h5>
              </div>
            </div>
            <div className=" col-12 pl-0">{children}</div>
            <div
              className="col-12 pl-3 pr-4"
              style={{ position: "absolute", bottom: "0" }}
            >
              <p>
                <MailOutlined className="text-danger" />{" "}
                <a
                  href="mailto:support@conceptx-ai.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  support@conceptx-ai.com
                </a>
                <span className="float-right">
                  <GlobalOutlined className="text-info" />{" "}
                  <a
                    href="https://www.conceptx-ai.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.conceptx-ai.com
                  </a>
                </span>
              </p>
            </div>
          </Col>
        </Row>
        <ToastContainer />
      </div>
    </Fragment>
  );
};

LoginApp.propTypes = {
  setLogoutProvision: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  setLogoutProvision: state.auth.setLogoutProvision,
});
export default connect(mapStateToProps, {})(LoginApp);
